
import { Component, Vue, Prop } from 'vue-property-decorator';
import Button from '../atoms/Button.vue';
import Close from '../atoms/Close.vue';
import BlurredImage from '../atoms/BlurredImage.vue';

@Component({
  components: {
    Button,
    BlurredImage,
    Close,
  },
})
export default class Modal extends Vue {
  @Prop({ default: false }) isDark!: boolean;
  @Prop({ default: false }) isRounded!: boolean;
  @Prop({ default: true }) isCloseable!: boolean;
  @Prop() primaryColor!: string;
  @Prop({ default: 0.6 }) opacity!: number;
  @Prop({ default: '100%' }) widthContent!: string;
  @Prop() imageUrl!: string;

  get classNames() {
    return [
      { 'modal--rounde': this.isRounded },
    ];
  }

  get contentStyle() {
    return {
      width: this.widthContent,
    };
  }
}
